const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
const SESSION_TOKEN_KEY = "spike_auth_token";

export function getSessionToken() {
  return window.localStorage.getItem(SESSION_TOKEN_KEY) || "";
}

export async function requestRadarJson(path, options = {}) {
  const token = getSessionToken();

  if (!token) {
    throw new Error("Authorization token is required");
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const responseText = await response.text();
  let payload = {};

  if (responseText) {
    try {
      payload = JSON.parse(responseText);
    } catch (error) {
      payload = {
        message: responseText,
      };
    }
  }

  if (!response.ok) {
    throw new Error(payload.message || "Request failed");
  }

  return payload;
}

export { API_BASE_URL };
